// Copyright 2021-2023 the .NET Foundation
// Licensed under the MIT License
// Note: module-level docstring found in `index.ts`
export var ImageSetTypes = ["earth", "planet", "sky", "panorama", "solarSystem", "sandbox"];
/** A type-guard function for {@link AddSourceMessage}. */
export function isAddSourceMessage(o) {
    return o.type === 'add_source' &&
        typeof o.source === 'object';
}
/** A type-guard function for {@link ModifySelectabilityMessage}. */
export function isModifySelectabilityMessage(o) {
    return o.type === 'modify_selectability' &&
        typeof o.id === 'string' &&
        typeof o.selectable === 'boolean';
}
/** A type-guard function for {@link ModifyAllSelectabilityMessage}. */
export function isModifyAllSelectabilityMessage(o) {
    return o.type === 'modify_all_selectability' &&
        typeof o.selectable === 'boolean';
}
//# sourceMappingURL=selections.js.map